import Main from '@/components/common/main'

export default [
    {
        path: '/moniter',
        name: 'Moniter',
        component: () => import('@/views/moniter.vue')
    },
    {
        path: '/oldmap',
        name: 'Map',
        component: () => import('@/views/map.vue')
    },
    {
        path: '/map',
        name: 'NewMap',
        component: () => import('@/views/new-map.vue')
    },
    {
        path: '/tokenlogin',
        name: 'TokenLogin',
        component: () => import('@/views/tokenlogin.vue')
    },
    {
        path: '/report',
        name: 'Report',
        component: () => import('@/views/report.vue')
    },
    {
        path: '/dun',
        name: 'Dun',
        component: () => import('@/views/dun.vue')
    },
    {
        path: '/loginlog',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/loginlog/list.vue')
            },
        ]
    },
    {
        path: '/offlinefile',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/offlinefile/list.vue')
            },
        ]
    },
    {
        path: '/systemlog',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/systemlog/list.vue')
            },
        ]
    },
    {
        path: '/producer',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/producer/list.vue')
            },
        ]
    },
    {
        path: '/alertmsg',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/alertmsg/list.vue')
            },
        ]
    },
    {
        path: '/alertlog',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/alertlog/list.vue')
            },
        ]
    },
    {
        path: '/projectdivision',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/projectdivision/list.vue')
            },
        ]
    },
    {
        path: '/workhole',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/workhole/list.vue')
            },
        ]
    },
    {
        path: '/workholecheck',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/workholecheck/list.vue')
            },
        ]
    },
    {
        path: '/arrange',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/arrange/list.vue')
            },
        ]
    },
    {
        path: '/devicework',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/devicework/list.vue')
            },
        ]
    },
    {
        path: '/devicecheck',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/devicecheck/list.vue')
            },
            {
                path: 'check',
                component: () => import('@/views/devicecheck/check.vue')
            },
        ]
    },
    {
        path: '/deviceextract',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/deviceextract/list.vue')
            },
            {
                path: 'extract',
                component: () => import('@/views/deviceextract/extract.vue')
            },
        ]
    },
    {
        path: '/deviceinfo',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/deviceinfo/list.vue')
            },
        ]
    },
    {
        path: '/devicetestlog',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/devicetestlog/list.vue')
            },
        ]
    },
    {
        path: '/plan',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/plan/list.vue')
            },
        ]
    },
    {
        path: '/plan',
        component: Main,
        children: [
            {
                path: 'rate',
                component: () => import('@/views/plan/rate.vue')
            },
        ]
    },
    {
        path: '/workreport',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/report_work/list.vue')
            },
            {
                path: 'import',
                component: () => import('@/views/report_work/import.vue')
            },
            {
                path: 'ocrimport',
                component: () => import('@/views/report_work/ocrimport.vue')
            },
            {
                path: 'csvimport',
                component: () => import('@/views/report_work/csvimport.vue')
            },
            {
                path: 'abnormal',
                component: () => import('@/views/report_work/abnormal.vue')
            },
            {
                path: 'interface',
                component: () => import('@/views/report_work/interface.vue')
            },
            {
                path: 'nodeal',
                component: () => import('@/views/report_work/nodeal.vue')
            },
        ]
    },
    {
        path: '/reportdealresult',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/reportdealresult/list.vue')
            },
            {
                path: 'listCheck',
                component: () => import('@/views/reportdealresult/list_checkhole.vue')
            },
        ]
    },
    {
        path: '/checkreport',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/report_check/list.vue')
            },
            {
                path: 'import',
                component: () => import('@/views/report_check/import.vue')
            },
            {
                path: 'abnormal',
                component: () => import('@/views/report_check/abnormal.vue')
            },
        ]
    },
    {
        path: '/extractreport',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/report_extract/list.vue')
            },
            {
                path: 'import',
                component: () => import('@/views/report_extract/import.vue')
            },
            {
                path: 'abnormal',
                component: () => import('@/views/report_extract/abnormal.vue')
            },
        ]
    },
    {
        path: '/diffreport',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/report_diff/list.vue')
            }
        ]
    },
    {
        path: '/messagelog',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/messagelog/list.vue')
            },
            {
                path: 'dataFilter',
                component: () => import('@/views/messagelog/dataFilter.vue')
            },
        ]
    },
    {
        path: '/messagelog',
        component: Main,
        children: [
            {
                path: 'filelist',
                component: () => import('@/views/messagelog/filelist.vue')
            },
        ]
    },
    {
        path: '/checkholeworkreport',
        component: Main,
        children: [
            {
                path: 'import',
                component: () => import('@/views/report_work_checkhole/import.vue')
            },
            {
                path: 'abnormal',
                component: () => import('@/views/report_work_checkhole/abnormal.vue')
            },
            {
                path: 'list',
                component: () => import('@/views/report_work_checkhole/list.vue')
            },
            {
                path: 'nodeal',
                component: () => import('@/views/report_work_checkhole/nodeal.vue')
            },
        ]
    },
    {
        path: '/checkholediffreport',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/report_diff_checkhole/list.vue')
            },
        ]
    },
    {
        path: '/checkholecheckreport',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/report_check_checkhole/list.vue')
            },
        ]
    },
    {
        path: '/device',
        component: Main,
        children: [
            {
                path: 'state1',
                component: () => import('@/views/device/moniter.vue')
            },
            {
                path: 'state',
                component: () => import('@/views/device/state.vue')
            },
        ]
    },
    {
        path: '/working',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/working/list.vue')
            },
        ]
    },
    {
        path: '/statistic',
        component: Main,
        children: [
            {
                path: 'hole',
                component: () => import('@/views/statistic/hole.vue')
            },
            {
                path: 'order',
                component: () => import('@/views/statistic/order.vue')
            },
            {
                path: 'unit',
                component: () => import('@/views/statistic/unit.vue')
            },
            {
                path: 'branch',
                component: () => import('@/views/statistic/branch.vue')
            },
            {
                path: 'company',
                component: () => import('@/views/statistic/company.vue')
            },
            {
                path: 'unitVerifyCheck',
                component: () => import('@/views/statistic/unitverifycheck.vue')
            },
            {
                path: 'unitVerifyDiff',
                component: () => import('@/views/statistic/unitverifydiff.vue')
            },
            {
                path: 'branchVerifyCheck',
                component: () => import('@/views/statistic/branchverifycheck.vue')
            },
            {
                path: 'branchVerifyDiff',
                component: () => import('@/views/statistic/branchverifydiff.vue')
            },
            {
                path: 'companyVerifyCheck',
                component: () => import('@/views/statistic/companyverifycheck.vue')
            },
            {
                path: 'companyVerifyDiff',
                component: () => import('@/views/statistic/companyverifydiff.vue')
            },
            {
                path: 'reportCount',
                component: () => import('@/views/statistic/reportcount.vue')
            },
        ]
    },
    {
        path: '/verify',
        component: Main,
        children: [
            {
                path: 'check',
                component: () => import('@/views/verify/check.vue')
            },
            {
                path: 'diff',
                component: () => import('@/views/verify/diff.vue')
            },
            {
                path: 'spot',
                component: () => import('@/views/verify/spot.vue')
            },
            {
                path: 'checkCheckHole',
                component: () => import('@/views/verify/checkCheckHole.vue')
            },
            {
                path: 'diffCheckHole',
                component: () => import('@/views/verify/diffCheckHole.vue')
            },
        ]
    },
    {
        path: '/projectconfig',
        component: Main,
        children: [
            {
                path: 'edit',
                component: () => import('@/views/projectconfig/edit.vue')
            }
        ]
    },
    {
        path: '/wtcg',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/wtcg/list.vue')
            }
        ]
    },
    {
        path: '/designdrawings',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/designdrawings/list.vue')
            }
        ]
    },
    {
        path: '/projectgroup',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/projectgroup/list.vue')
            }
        ]
    },
    {
        path: '/groupuser',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/groupuser/list.vue')
            }
        ]
    },
    {
        path: '/superuser',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/groupuser/superlist.vue')
            }
        ]
    },
    {
        path: '/projectuser',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/groupuser/projectuserlist.vue')
            }
        ]
    },
    {
        path: '/monthreport',
        component: Main,
        children: [
            {
                path: 'list1',
                component: () => import('@/views/monthreport/list1.vue')
            },
            {
                path: 'list2',
                component: () => import('@/views/monthreport/list2.vue')
            },
            {
                path: 'list3',
                component: () => import('@/views/monthreport/list3.vue')
            }
        ]
    },
    {
        path: '/alertcancellog',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/alertcancellog/list.vue')
            },
        ]
    },
    {
        path: '/usermonitor',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/usermonitor/list.vue')
            },
        ]
    },
    {
        path: '/dayreport',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/dayreport/list.vue')
            },
        ]
    },
    {
        path: '/flowmeter',
        component: Main,
        children: [
            {
                path: 'list1',
                component: () => import('@/views/flowmeter/list1.vue')
            },
            {
                path: 'list2',
                component: () => import('@/views/flowmeter/list2.vue')
            },
            {
                path: 'list3',
                component: () => import('@/views/flowmeter/list3.vue')
            },
            {
                path: 'list4',
                component: () => import('@/views/flowmeter/list4.vue')
            },
        ]
    },
    {
        path: '/tablets',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/tablets/list.vue')
            },
        ]
    },
    {
        path: '/routers',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/routers/list.vue')
            },
        ]
    },
    {
        path: '/netcard',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/netcard/list.vue')
            },
        ]
    },
    {
        path: '/devicerelationtimelog',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/devicerelationtimelog/list.vue')
            },
        ]
    },
    {
        path: '/cryptodog',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/cryptodog/list.vue')
            },
        ]
    },
    {
        path: '/recordmsg',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/recordmsg/list.vue')
            },
        ]
    },
    {
        path: '/deviceinspectionlog',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/deviceinspectionlog/list.vue')
            },
        ]
    },
    {
        path: '/deviceinspectionreport',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/deviceinspectionreport/list.vue')
            },
        ]
    },
    {
        path: '/reportcontrast',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/report_contrast/list.vue')
            },
            {
                path: 'listCheckHole',
                component: () => import('@/views/report_contrast/listCheckHole.vue')
            },
        ]
    },
    {
        path: '/orgrole',
        component: Main,
        children: [
            {
                path: 'orglist',
                component: () => import('@/views/orgrole/orglist.vue')
            }
        ]
    },
    {
        path: '/accesstoken',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/accesstoken/list.vue')
            }
        ]
    },
    {
        path: '/visitlimit',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/visitlimit/list.vue')
            }
        ]
    },
    {
        path: '/singlesignon',
        component: Main,
        children: [
            {
                path: 'list',
                component: () => import('@/views/singlesignon/list.vue')
            }
        ]
    },
]